import {
  PSMS_PAYMENT_INTEGRITY_DATA_LOADING,
  PSMS_PAYMENT_INTEGRITY_DATA_REQUEST,
  PSMS_PAYMENT_INTEGRITY_DATA_SUCCESS,
  PSMS_PAYMENT_INTEGRITY_DATA_FAILURE,
  PSMS_EVAlUATION_DETAILS_DATA_REQUEST,
  PSMS_EVAlUATION_DETAILS_DATA_LOADING,
  PSMS_EVAlUATION_DETAILS_DATA_SUCCESS,
  PSMS_AUDIT_REASON_CODE_DATA_REQUEST,
  PSMS_AUDIT_REASON_CODE_DATA_LOADING,
  PSMS_AUDIT_REASON_CODE_DATA_SUCCESS,
} from '../actionTypes';

export const getPSMSPaymentIntegritySummary = <TPayload>(payload: TPayload) => ({
  type: PSMS_PAYMENT_INTEGRITY_DATA_REQUEST,
  payload,
});

export const getPSMSPaymentIntegrityLoading = (payload: boolean) => ({
  type: PSMS_PAYMENT_INTEGRITY_DATA_LOADING,
  payload,
});

export const getPSMSPaymentIntegrityDataSuccess = <TPayload>(payload: TPayload) => ({
  type: PSMS_PAYMENT_INTEGRITY_DATA_SUCCESS,
  payload,
});

export const getPSMSPaymentIntegrityDataFailure = <TPayload>(payload: TPayload) => ({
  type: PSMS_PAYMENT_INTEGRITY_DATA_FAILURE,
  payload,
});

export const getPSMSEvaluationDetailsDataSuccess = <TPayload>(payload: TPayload) => ({
  type: PSMS_EVAlUATION_DETAILS_DATA_SUCCESS,
  payload,
});

export const getPSMSEvaluationDetailsData = <TPayload>(payload: TPayload) => ({
  type: PSMS_EVAlUATION_DETAILS_DATA_REQUEST,
  payload,
});

export const getPSMSEvaluationDetailsDataLoading = <TPayload>(payload: TPayload) => ({
  type: PSMS_EVAlUATION_DETAILS_DATA_LOADING,
  payload,
});

export const getAuditReasonCodeDataLoading = <TPayload>(payload: TPayload) => ({
  type: PSMS_AUDIT_REASON_CODE_DATA_LOADING,
  payload,
});

export const getAuditReasonCodeData = <TPayload>(payload: TPayload) => ({
  type: PSMS_AUDIT_REASON_CODE_DATA_REQUEST,
  payload,
});

export const getAuditReasonCodeDataSuccess = <TPayload>(payload: TPayload) => ({
  type: PSMS_AUDIT_REASON_CODE_DATA_SUCCESS,
  payload,
});
